import Open from './Open';
import Closed from './Closed';

export default {
    Closed,
    Open,
};
